import { FrontEndProcesssingSummary } from './FrontEndProcessingSummary';
import { ProductDetailsSummary } from '../../summary/ProductDetailsSummary';
import { modalUtils } from '@/app/core/utils';
import { ExperianIcon } from '@/app/features/products/summary/ExperianIcon';
import { ProgramSummaryFooter } from '@/app/features/products/summary/ProgramSummaryFooter';
import { getAscendArchivesOutputLayoutFieldsWithDetailsAndRowColor } from '@/app/features/products/common/services/program-service';
import { OutputFileLayoutSummary } from '@/app/features/products/summary/OutputFileLayoutSummary';
import {
  AscendArchivesProgram,
  HasRowColor,
  OutputLayoutFieldWithDetails,
  ProgramDataType,
  Job,
} from '@ssar-app/domain';
import { useEffect, useState, Fragment } from 'react';
import { Modal, Spin } from '@ssar-app/uikit';
import { Flex, Text } from '@chakra-ui/react';

export interface ProgramSummaryModalProps {
  model: ProgramDataType;
  job?: Job;
  version: string;
  onCancel?: () => void;
  showAccept?: boolean;
  onAccept?: () => void;
  onOk?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDownload?: (arg0: any) => void;
  programId: string;
}

interface SummaryDataContainer {
  outputLayoutFieldsWithDetailsAndRowColor: HasRowColor<OutputLayoutFieldWithDetails>[];
}
export const ProgramSummaryModal = (props: ProgramSummaryModalProps) => {
  const { model, job, programId, version } = props;
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [summaryDataContainer, setSummaryDataContainer] =
    useState<SummaryDataContainer>();
  const summaryModel = props.model as AscendArchivesProgram;
  useEffect(() => {
    setIsLoadingData(true);
    Promise.all([
      getAscendArchivesOutputLayoutFieldsWithDetailsAndRowColor(
        summaryModel?.subCode || '',
        version,
        programId,
      ),
    ])
      .then((responses) => {
        const failedResponses = responses.filter((a) => a.resultCode !== 0);
        if (failedResponses.length > 0) {
          let errors: string[] = [];
          failedResponses.forEach((a) => {
            errors = errors.concat(a.messages);
          });
          throw new Error(`Error while loading lookups:${errors.join('\\n')}`);
        } else {
          const [outputLayoutFieldsWithDetailsAndRowColorResponse] = responses;
          return {
            outputLayoutFieldsWithDetailsAndRowColor:
              outputLayoutFieldsWithDetailsAndRowColorResponse.data || [],
          };
        }
      })
      .then((values) => {
        const { outputLayoutFieldsWithDetailsAndRowColor } = values || {};
        setSummaryDataContainer({
          outputLayoutFieldsWithDetailsAndRowColor,
        });
      })
      .catch((err) => {
        console.error(err);
        modalUtils.showError(err);
      })
      .finally(() => {
        setIsLoadingData(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model, programId, job, version, setIsLoadingData]);

  return (
    <Fragment>
      <Modal
        footer={
          isLoadingData ? (
            <></>
          ) : (
            <ProgramSummaryFooter
              model={summaryModel}
              showAccept={props.showAccept}
              onAccept={props.onAccept}
              onCancel={props.onCancel}
              onDownload={props.onDownload}
              onOk={props.onOk}
            />
          )
        }
        isOpen
        header='Program Summary'
        contentProps={{ maxW: '80%' }}
        onClose={() => {
          const closeFn = props.onCancel || props.onOk;
          closeFn && closeFn();
        }}
      >
        {summaryModel && (
          <Fragment>
            <style
              dangerouslySetInnerHTML={{
                __html: `
                  * {
                    scrollbar-width: thin;
                    scrollbar-color: #A6A6A6 #A6A6A6;
                  }
                  *::-webkit-scrollbar {
                    width: 10px;
                    height: 10px;
                  }
                  *::-webkit-scrollbar-track {
                    background: #D9D9D9;
                  }
                  *::-webkit-scrollbar-thumb {
                    background-color: #A6A6A6;
                    border-radius: 20px;
                  }

                  `,
              }}
            ></style>
            <Spin spinning={isLoadingData} tip=''>
              {isLoadingData && (
                <Text textAlign='center' mt={20}>
                  Loading program summary data...
                </Text>
              )}
              {!isLoadingData && (
                <>
                  <Flex direction='column'>
                    <ExperianIcon />
                    <Text as='span' textColor='blue.500'>
                      Program Summary
                    </Text>
                    <ProductDetailsSummary
                      job={props?.job}
                      productDetails={
                        summaryModel?.productInput?.productDetails
                      }
                    />
                    <br />
                    <br />
                    <FrontEndProcesssingSummary
                      model={summaryModel?.packagesInput.frontEndProcessing}
                    />
                    <br />
                    <br />
                    {/* <InquiryLoggingSummary
                      subCode={summaryModel?.subCode || ''}
                    />
                    <br />
                    <br />
                    <br /> */}
                    <OutputFileLayoutSummary
                      header='Input File Header Mappings'
                      programName={
                        summaryModel?.productInput.productDetails.programName
                      }
                      outputLayoutFieldsWithDetailsAndRowColor={{
                        outputLayout:
                          summaryDataContainer?.outputLayoutFieldsWithDetailsAndRowColor ||
                          [],
                      }}
                    />
                  </Flex>
                </>
              )}
            </Spin>
          </Fragment>
        )}
      </Modal>
    </Fragment>
  );
};
